openVideoModal = function(action = 1, url = null) {
    // Ejemplo de url => https://www.youtube.com/embed/xMWgEwJ7w-8;
    url = `${url}?autoplay=1&amp;amp;modestbranding=1&amp;amp;showinfo=0`;
    // set video frame src
    let videoFrame = document.getElementById('videoFrame');
    if (videoFrame === null) {
        controlVideo('start');
        videoFrame = document.getElementById('videoFrame');
    }
    // set src
    videoFrame.src = url;
    // open modal
    const popUpContainer = document.getElementById("modalVideoTileCard");
    popUpContainer.classList.add("open");
    // close modal
    popUpContainer.querySelector(".close-video-popup").addEventListener("click", () => {
        popUpContainer.classList.remove("open");
        controlVideo('stop');
    });
}

controlVideo = function(vidFunc, parentVideoFrameId = 'parentVideoFrame') {
    console.log(vidFunc);
    let parentVideoFrame = document.getElementById(parentVideoFrameId);
    switch (vidFunc) {
        case 'stop':
            if (parentVideoFrame) {
                parentVideoFrame.innerHTML = "";
            }
            break;
        case 'start':
            if (parentVideoFrame) {
                parentVideoFrame.innerHTML = `<iframe id="videoFrame" title="YouTube video" 
                        frameborder="0" allowfullscreen="" allowscriptaccess="always" 
                        allow="autoplay">
                    </iframe>`;
            }
            break;
        default:
            break;
    }
}
  